<template>
	<div class="h100 analyze_left">
		<div class="title">{{ tabTitle === 0 || tabTitle === 1 ? '材料选择' : '工种选择'}}</div>
		<div class="content">
			<div class="checkbox_title">
				<div class="checkbox_title_left">
					<div class="fold"
						 @click="boxshow = !boxshow">
						<i :class="[boxshow?'up':'down']"
						   class="el-icon-arrow-down"></i>
					</div>
					<el-checkbox :indeterminate="isIndeterminate"
								 class="allCheck"
								 v-model="checkAll"
								 @change="handleCheckAllChange">{{ tabTitle === 0 || tabTitle === 1 ? '主要材料' : '主要工种'}}
					</el-checkbox>
				</div>
				<div class="checkbox_title_right">
					<span>{{checkedCities.length}}/{{selects.length}}</span>
					<i v-if="tabTitle === 0 || tabTitle === 1"
					   class="el-icon-circle-plus"></i>
				</div>
			</div>
			<transition name="toTop"
						class="toTop">
				<el-checkbox-group v-model="checkedCities"
								   v-show="boxshow"
								   @change="handleCheckedCitiesChange">
					<el-checkbox v-for="city in selects"
								 :label="city"
								 :key="city">{{city}}</el-checkbox>
				</el-checkbox-group>
			</transition>
		</div>
	</div>
</template>
<script>
import { selectProfessions } from '@/api/modules/analyze_tab'
export default {
	name: 'analyze_tab_left',
	props: {
		tabTitle: {
			type: Number,
			default: null
		}
	},
	data() {
		return {
			checkedCount: 0,
			boxshow: true,
			activeName: '1',
			checkAll: false,
			checkedCities: [],
			checkAllList: [],
			selects: [],
			selectsCode: [],
			isIndeterminate: true
		}
	},
	created() {},
	mounted() {
		this.$nextTick(() => {
			this.getProfessions()
		})
	},
	methods: {
		//初始化数据
		getProfessions() {
			let that = this
			selectProfessions({}).then(res => {
				if (res.code === 0) {
					let checkAllList = []
					checkAllList = res.data
					this.checkAllList = checkAllList
					this.selects = checkAllList.map(val => {
						return val.sname
					})
					that.checkedCities.push(this.selects[0],this.selects[1],this.selects[2])
					this.selectsCode = this.checkAllList
						.filter(v => {
							return that.checkedCities.includes(v.sname)
						})
						.map(function(v) {
							return v.code
						})
				}
			})
		},

		handleCheckAllChange(val) {
			let that = this
			this.checkedCities = val ? this.selects : []
			this.isIndeterminate = false

			this.checkedCount = this.checkedCities.length

			let checkedList = this.checkAllList.filter(v => {
				return that.checkedCities.includes(v.sname)
			})
			this.selectsCode = checkedList.map(function(v) {
				return v.code
			})
		},
		handleCheckedCitiesChange(value) {
			let checkedCount = value.length
			this.checkedCount = checkedCount
			this.checkAll = checkedCount === this.selects.length
			this.isIndeterminate =
				checkedCount > 0 && checkedCount < this.selects.length

			let that = this
			let array = that.checkedCities.concat()
			// if (!array.includes(value)) array.push(value)
			// that.checkedCities = array.concat()
			let arr = array.filter(item => !value.some(ele => ele == item))
			if (arr.length != 0) array = array.concat(arr)
			that.checkedCities = array.concat()
			let checkedList = this.checkAllList.filter(v => {
				return that.checkedCities.includes(v.sname)
			})
			this.selectsCode = checkedList.map(function(v) {
				return v.code
			})
		}
	},
	computed: {},
	watch: {
		selectsCode: {
			handler(val) {
				this.$emit('on-codes', val)
			},
			deep: true
		}
	}
}
</script>
<style scoped lang="less">
.analyze_left {
	position: relative;
	padding-top: 30px;
	height: 100%;
	box-sizing: border-box;
	overflow: hidden;
	.title {
		position: absolute;
		top: 0;
		left: 0;
		padding: 0 10px;
		width: 100%;
		height: 30px;
		line-height: 30px;
		color: #333;
		font-size: 18px;
		font-weight: bold;
	}
	.content {
		height: 100%;
		overflow: auto;
		.checkbox_title {
			display: flex;
			background: #ecf5fb;
			line-height: 33px;
			padding: 0 10px;

			.checkbox_title_left {
				flex: 1;
				color: #606266;
				.fold {
					display: inline-block;
					height: 100%;
					padding: 0 10px 0 0;
					cursor: pointer;
					.up {
						transition: all 0.5s;
					}

					.down {
						transform: rotate(-90deg);
						transition: all 0.5s ease;
					}
				}
			}
			.checkbox_title_right {
				flex: 1;
				text-align: right;
				cursor: pointer;
				span {
					color: rgb(102, 102, 102);
					font-size: 14px;
				}
				i {
					color: #ef9200;
					font-size: 18px;
					vertical-align: middle;
				}
			}
		}
	}
}
</style>